// JavaScript code for sn/search-results component
(($) => {

     "use strict";
     console.log("sn/search-results scripts loaded...");

})(jQuery);